import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import AtivandoDoacao from "@/pages/AtivandoDoacao";

export const Route = createFileRoute("/ativando-doacao")({
  head: () => seoHead({
    title: "Ativando sua doação | Shopping do Bem",
    description: "Estamos ativando sua doação e levando você até a loja parceira.",
    path: "/ativando-doacao",
    noindex: true,
  }),
  component: AtivandoDoacao,
});
